import basicPalette from './defaultPalettes/basic';
import colorfulPalette from './defaultPalettes/colorful';
export var defaultPalettes = [basicPalette, colorfulPalette];
export var ADDON_ID = 'color-picker';
export var TOOL_ID = "".concat(ADDON_ID, "/tool");